import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { t } from '../../../../modules/infra/i18n';

import Tooltip from '../../../common/tooltip';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import Modal from '../../../common/Modal';
import withToggle from '../../../common/hoc/withToggle';
import UploadPhoto from '../../../common/uploadPhotoForm/uploadPhoto';

const buildPreviewStyles = logoUrl => ({
  height: '450px',
  backgroundImage: `url("${logoUrl}")`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
});

const KioskLogoControls = props => (
  <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
    <Modal
      display-if={props.previewIsOn}
      title={t('brand:form.kiosk_logo_preview_title')}
      showCloseButton
      close={props.previewOff}
    >
      <div style={buildPreviewStyles(props.previewSrc)} />
    </Modal>
    <CheckboxSwitch
      name="settings.customKioskLogoEnabled"
      id="settings.customKioskLogoEnabled"
      label={t('brand:form.use_custom_logo_for_kiosk_label')}
    />
    <Tooltip
      className="c-info-tooltip-new"
      text={t('brand:form.kiosk_logo_tooltip')}
    />
    <button
      display-if={props.previewSrc && props.canUpload}
      type="button"
      className="c-btn c-btn--small u-ml--"
      onClick={props.previewOn}
    >
      {t('brand:form.kiosk_logo_current_image_button')}
    </button>
    <UploadPhoto className="u-lineheight-0" name="settings.customKioskLogo" display-if={props.canUpload}>
      {() => (
        <div className="c-btn c-btn--small u-ml--">
          { props.previewSrc ? t('brand:form.kiosk_logo_change_button') : t('brand:form.kiosk_logo_upload_button') }
        </div>
      )}
    </UploadPhoto>
  </div>
);

KioskLogoControls.propTypes = {
  canUpload: PropTypes.bool.isRequired,
  previewSrc: PropTypes.string,
  previewIsOn: PropTypes.bool.isRequired,
  previewOff: PropTypes.func.isRequired,
  previewOn: PropTypes.func.isRequired,
};

export default compose(
  withToggle('preview', false),
  withProps(props => ({
    previewSrc: props.customKioskLogo && (
      props.customKioskLogo instanceof File
        ? URL.createObjectURL(props.customKioskLogo)
        : props.customKioskLogo.url
    ),
    canUpload: !!props.customKioskLogoEnabled,
  })),
)(KioskLogoControls);
